import Vue from 'vue'
import Echo from 'laravel-echo';
import io from 'socket.io-client';

window.io = io;

const echo = new Echo({
    broadcaster: 'socket.io',
    host: process.env.VUE_APP_URL + ':6001',
});

Vue.prototype.$echo = echo;

export default echo;
